<template>
  <div>
    <b-button size="sm" v-if="show" :disabled="press" block href="#" variant="primary" @click="$emit('save')">
      {{ preview != true ? 'セーブ' : '変更' }}
    </b-button>
      <b-card v-if="show" style="padding: 1px !important;">
        <b-input-group>
          <b-form-input v-if="preview != true" id="ph_white_path" v-model="path" placeholder="Select file or path for white list" @keyup.native.enter="add(path)">
          </b-form-input>
          <b-input-group-append>
            <b-button variant="primary" v-show="preview != true" @click="add(path)">追加</b-button>
          </b-input-group-append>
          <b-input-group-append>
            <b-button variant="warning" v-show="preview != true" :disabled="white_path.length == 0" @click="clear(path)">クリア</b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-group>
          <b-list-group>
            <b-list-group-item style="padding: 10px 30px 10px 30px !important;" v-for="(item, index) in white_path" :key="index">
              <i v-show="preview != true" class="fa fa-times" @click="remove(index)"></i> {{item}}
            </b-list-group-item>
          </b-list-group>
        </b-form-group>
      </b-card>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>